import { getWorkflowDrawerOptions } from '@talos/kyoko';
import { startCase } from 'lodash-es';

const CUSTOMER_WORKFLOW_DRAWER_OPTIONS = getWorkflowDrawerOptions();

export const CUSTOMER_WORKFLOW_FILTER_OPTIONS = CUSTOMER_WORKFLOW_DRAWER_OPTIONS.map(({ value }) => value);

const CUSTOMER_WORKFLOW_FILTER_OPTION_LABELS = new Map(
  CUSTOMER_WORKFLOW_DRAWER_OPTIONS.map(({ value, label }) => [value, label])
);

export function getCustomerWorkflowFilterOptionLabel(option: string) {
  return CUSTOMER_WORKFLOW_FILTER_OPTION_LABELS.get(option) ?? startCase(option);
}
